import React from 'react';
import {
  Field,
  getIn
} from 'formik';
import cn from 'classnames';

const ErrorMessage = ({ name, isCounter ,isLandScape, emailIsCounter, isDriveThru }) => (
  <Field
    name={name}
    render={({ form }) => {
      const error = getIn(form.errors, name);
      const touch = getIn(form.touched, name);
      return (touch || form.submitCount > 0) && error ? (
        <small className={cn("error d-flex justify-content-end text-right fs-14")} style={{paddingRight : (isCounter || isDriveThru) && isLandScape && emailIsCounter ? '3.4rem' : ''}}>
          {error}
        </small>
      ) : null;
    }}
  />
);
export default ErrorMessage;
